/**
 * Handmade Naan — scroll reveals for step media/copy.
 * Pre-reveal opacity only applies after .is-ready is set, so missing JS
 * never leaves content stuck invisible.
 */
(function () {
  'use strict';

  function initSection(root) {
    if (!root || root.dataset.hnInit === '1') return;
    root.dataset.hnInit = '1';

    var steps = root.querySelectorAll('.handmade-naan__step');
    if (!steps.length) return;

    root.querySelectorAll('.handmade-naan__video').forEach(function (video) {
      var start = parseFloat(video.getAttribute('data-start'));
      var src = video.currentSrc || (video.querySelector('source') && video.querySelector('source').src) || '';
      if (!(start > 0) && /handmade-naan-step-2\.mp4/.test(src)) start = 8.5;
      if (!(start > 0)) return;
      video.setAttribute('data-start', String(start));

      var started = false;

      function jumpToStart() {
        if (video.currentTime + 0.05 < start) {
          video.currentTime = start;
        }
        if (!started) {
          started = true;
          video.classList.add('is-started');
        }
      }

      video.addEventListener('loadedmetadata', jumpToStart);
      video.addEventListener('seeked', function () {
        video.classList.add('is-started');
      });
      video.addEventListener('playing', jumpToStart);
      video.addEventListener('timeupdate', function () {
        if (video.currentTime + 0.05 < start) {
          video.currentTime = start;
        }
      });

      if (video.readyState >= 1) jumpToStart();
      window.setTimeout(function () {
        video.classList.add('is-started');
      }, 1200);
    });

    var reduceMotion =
      window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function reveal(step) {
      step.classList.add('is-visible');
    }

    if (reduceMotion) {
      steps.forEach(reveal);
      return;
    }

    if (!('IntersectionObserver' in window)) {
      steps.forEach(reveal);
      return;
    }

    var observer = new IntersectionObserver(
      function (entries, obs) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          reveal(entry.target);
          obs.unobserve(entry.target);
        });
      },
      { threshold: 0.18, rootMargin: '0px 0px -8% 0px' }
    );

    // Paint the pre-reveal state before observing so transitions can run.
    steps.forEach(function (step) {
      step.classList.add('is-ready');
    });

    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        steps.forEach(function (step) {
          observer.observe(step);
        });
      });
    });
  }

  function initAll() {
    document.querySelectorAll('.handmade-naan').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target && event.target.querySelector
      ? event.target.querySelector('.handmade-naan')
      : null;
    if (root) {
      delete root.dataset.hnInit;
      initSection(root);
    } else {
      initAll();
    }
  });
})();
